import { sbxCoreService} from '../Network';
import Contact from "../Models/Contact";
import {ISearchContact} from "../Store/Contact/Types";
const MODEL = "contact"

export function getContacts(criteria?: ISearchContact) {
  let query =  sbxCoreService.with(MODEL);

  if (criteria) {
    if (criteria.name && criteria.name.trim() !== "") query.andWhereItContains("name", criteria.name);

    if (criteria.phone && criteria.phone.trim() !== "") query.andWhereItContains("phone", criteria.phone);

    if (criteria.cellphone && criteria.cellphone.trim() !== "") query.andWhereItContains("cellphone", criteria.cellphone);

    if (criteria.customer && criteria.customer.trim()) query.andWhereIsEqualTo("customer", criteria.customer);
  }

  return query.fetchModels(["customer"]).loadAll(["customer"]);
}

export function saveContact(contact: Contact) {
  if (!contact._KEY) {
    return sbxCoreService.with(MODEL)
      .insert(contact);
  }

  return sbxCoreService.with(MODEL)
    .whereWithKeys([contact._KEY])
    .update(contact);
}

export function deleteContact(contact: Contact) {
  return sbxCoreService.with(MODEL)
    .whereWithKeys([contact._KEY])
    .delete();
}
